import i18n from '../../i18n';

const step = (mode, id) => ({
  id,
  label: i18n.t(`modules.shared.aiAgent.thinkingSteps.${mode}.${id}`),
});

const buildSteps = (mode, ids) => ids.map((id) => step(mode, id));

export const AGENT_THINKING_STEPS = {
  plan: buildSteps('plan', ['analyze', 'context', 'match', 'structure', 'finalize']),
  agent: buildSteps('agent', ['analyze', 'context', 'intent', 'respond']),
  ask: buildSteps('ask', ['analyze', 'context', 'respond']),
  analyse: buildSteps('analyse', ['analyze', 'context', 'insights', 'report']),
  build: buildSteps('build', ['switch', 'plan', 'execute']),
};

export function getThinkingSteps(agentMode, isBuildingPlan = false) {
  if (isBuildingPlan) return AGENT_THINKING_STEPS.build;
  return AGENT_THINKING_STEPS[agentMode] || AGENT_THINKING_STEPS.agent;
}

export function getThinkingTitle(agentMode, isBuildingPlan = false) {
  if (isBuildingPlan) {
    return i18n.t('modules.shared.aiAgent.thinkingSteps.titles.build');
  }
  return i18n.t(`modules.shared.aiAgent.thinkingSteps.titles.${agentMode}`, {
    defaultValue: i18n.t('modules.shared.aiAgent.thinkingSteps.titles.agent'),
  });
}
